import gql from 'graphql-tag';

const SEND_ORDER_INVOICE_MAIL = gql`
    mutation sendOrderInvoiceMail($orderId: String) {
        sendOrderInvoiceMail(orderId: $orderId) {
            internalCode
        }
    }
`;

export default SEND_ORDER_INVOICE_MAIL;
